import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Loader2, MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/components/AuthShell";
import { api, errMsg } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState("");
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setDone(data.message);
    } catch (ex) {
      setErr(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell>
      <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 mb-8" data-testid="back-to-login-link">
        <ArrowLeft className="w-4 h-4" /> Tilbake til innlogging
      </Link>
      <h2 className="font-display text-3xl font-semibold tracking-tight">Glemt passord</h2>
      <p className="mt-2 text-sm text-slate-500">Skriv inn e-postadressen din, så sender vi deg en lenke for å velge nytt passord.</p>
      {done ? (
        <div className="mt-8 flex gap-3 rounded-md border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800" data-testid="forgot-success">
          <MailCheck className="w-5 h-5 shrink-0" /> {done}
        </div>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div className="space-y-2">
            <Label htmlFor="email">E-post</Label>
            <Input id="email" type="email" required autoComplete="email" value={email}
              onChange={(e) => setEmail(e.target.value)} className="h-11" data-testid="forgot-email-input" />
          </div>
          {err && <p className="text-sm text-red-700" data-testid="forgot-error">{err}</p>}
          <Button type="submit" disabled={busy} className="w-full h-11" data-testid="forgot-submit-button">
            {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Send lenke
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
